import { Pipe, PipeTransform } from '@angular/core';

import { IBomModel } from '../../prisma-xs/models/bom.model';

@Pipe({
    name: 'canTransferToWholesaler',
    standalone: false
})
export class CanTransferToWholesalerPipe implements PipeTransform {

  transform(bomModels: IBomModel[]): IBomModel[] {
    return bomModels?.filter(m => m.article.canTransferToWholesaler);
  }

}
